export const en = {
    'feedback-already-exists': 'You can only leave one review per expert. Please edit your previous review',
    'feedback-not-found': 'Unable to find the edited review in our database. Please refresh the page and try again',
    'incorrect-feedback-text-size': 'The review comment must contain at least three characters.',
    'operator-has-no-project-with-freelancer':
        'You cannot post a review on this expert as you have not worked with them.',
    'operator-has-wrong-role': 'You cannot post reviews for Yandex.Direct experts',
    'operator-is-not-chief': 'You cannot post reviews for Yandex.Direct experts'
};
